export const getActiveDepth = state => state.ui.menu.activeTrail.length || 0;

export const getActiveTrail = state => state.ui.menu.activeTrail;

export const isOpen = state => state.ui.menu.isOpen;

export const isMobile = state => state.ui.menu.isMobile;

export const getIsActive = item => state => state.ui.menu.activeTrail.includes(item?.key) || false;

export const getIsMenuOpenMobile = state => state.ui.menu.mobile.isOpen;
